import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/users/load',
    method: 'post',
    data
  });
}

export function get(params) {
  return request({
    url: '/users/get',
    method: 'get',
    params
  });
}

export function getUserLK(params) {
  return request({
    url: '/users/GetUserLK',
    method: 'get',
    params
  });
}

export function GetErpUser(data) {
  return request({
    url: '/lksysusers/GetErpUser',
    method: 'post',
    data
  });
}

export function add(data) {
  return request({
    url: '/users/addorupdate',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/users/addorupdate',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/users/delete',
    method: 'post',
    data
  });
}

export function loadByRole(params) {
  return request({
    url: '/users/loadByRole',
    method: 'get',
    params
  });
}

export function changePassword(data) {
  return request({
    url: '/users/ChangePassword',
    method: 'post',
    data
  });
}

export function changeUserInfo(data) {
  return request({
    url: '/users/ChangeUserInfo',
    method: 'post',
    data
  });
}

export function changeProfile(data) {
  return request({
    url: '/users/ChangeProfile',
    method: 'post',
    data
  });
}

export function postMessageByUser(params) {
  return request({
    url: '/BaseMessages/PostMessageByUser',
    method: 'get',
    params
  });
}
